export default class hideFromAffiliates {
	/**
	 * Get a parameter value from the URL.
	 *
	 * @param {string} name Parameter name.
	 * @return {string}     Parameter value.
	 */
	getUrlParameter( name ) {
		name = name.replace( /[\[]/, '\\[' ).replace( /[\]]/, '\\]' );
		const regex = new RegExp( '[\\?&]' + name + '=([^&#]*)', 'i' );
		const results = regex.exec( location.search );
		return null === results
			? ''
			: decodeURIComponent( results[ 1 ].replace( /\+/g, ' ' ) );
	}

	/**
	 * Run our script to hide elements.
	 */
	hide() {
		const ssaid =
			this.getUrlParameter( 'SSAID' ) ||
			localStorage.getItem( 'wpe-ssaid' );

		if ( ! ssaid ) {
			return;
		}

		const blocks = document.querySelectorAll( '[data-ssaid]' );

		// Loop through blocks.
		[].forEach.call( blocks, function ( entry ) {
			let blockSsaids = entry.getAttribute( 'data-ssaid' );
			blockSsaids = JSON.parse( blockSsaids );

			blockSsaids.forEach( function ( blockSsaid ) {
				// If block SSAIDs match, hide the block.
				if ( blockSsaid === ssaid ) {
					entry.style.display = 'none';
				}
			} );
		} );

		localStorage.setItem( 'wpe-ssaid', ssaid );
	}
}
